import { render, staticRenderFns } from "./OrgStaffCMScorecard.vue?vue&type=template&id=29c3a1b3&scoped=true&"
import script from "./OrgStaffCMScorecard.vue?vue&type=script&lang=js&"
export * from "./OrgStaffCMScorecard.vue?vue&type=script&lang=js&"
import style0 from "./OrgStaffCMScorecard.vue?vue&type=style&index=0&id=29c3a1b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c3a1b3",
  null
  
)

export default component.exports